import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';

$(() => {
  const userBidderId = parseInt($('input#_auction-bidder-id').val());
  const secondsToClosing = parseInt($('input#_seconds-to-closing').val());
  const winningBidderId = parseInt($('input#_winning_bidder_id').val());
  const bidderIds = JSON.parse($('input#_bidder-ids').val()) || [];
  const isReserveMet = $('input#_is-reserve-met').val() === 'True';
  const isSTC = $('input#_is-stc').val() === 'True';

  const HEADERS = {
    MAIN_LIVE: $('.bidding-header__main--live'),
    MAIN_ENDED: $('.bidding-header__main--ended'),
    SUBHEADER_WINNER: $('.bidding-header__subheader--winner'),
  };

  const setHeaderState = ({
    userBidderId,
    bidderIds,
    winningBidderId,
    secondsToClosing,
    isReserveMet,
  }) => {
    const isUserBidding = bidderIds.includes(userBidderId);

    if (secondsToClosing > 0) {
      HEADERS.MAIN_LIVE.show();
      HEADERS.MAIN_ENDED.hide();
    } else {
      HEADERS.MAIN_LIVE.hide();
      HEADERS.MAIN_ENDED.show();

      if (isUserBidding && (isSTC || isReserveMet)) {
        if (userBidderId === winningBidderId) {
          HEADERS.SUBHEADER_WINNER.show();
        }
      }
    }
  };

  setHeaderState({
    userBidderId,
    bidderIds,
    winningBidderId,
    secondsToClosing,
    isReserveMet,
  });

  EVENT_BUS.on(
    AUCTION_EVENTS.AUCTION_CLOSED,
    ({ userBidderId, secondsToClosing, bidderIds, isReserveMet }) => {
      const winningBidderId = bidderIds[0];
      setHeaderState({
        userBidderId,
        bidderIds,
        winningBidderId,
        secondsToClosing,
        isReserveMet,
      });
    }
  );
});
